import React from 'react';
import BaseClass from '@/pages/BaseClass';

import $ from 'jquery';
import {
	Button,
	Input,
	Form,
	Select,
	Steps,
	Upload,
	Image,
} from 'antd'
import {
	CommonValue,
	ngUrl,
	pcUrl,
	confirm,
	message,
	notify,
	httpPost,
	getQuery,
} from '@/utils/Tools';

const {Option} = Select;
export default class App extends BaseClass
{
	constructor(props)
	{
		super(props);
		
		this.state={
			'reasonList':{},
			'solutionList':{},
			'info':{},
			'rules':{
				'service_reason':[
					{
						required: true,
						message: '请选择售后原因',
					},
				],
				'order_sn':[
					{
						required: true,
						message: '请输入订单号',
					},
				],
				'problem_desc':[
					{
						required: true,
						message: '请输入问题描述',
					},
				],
				'service_solution':[
					{
						required: true,
						message: '请选择意向解决方案',
					},
				],
				'phone':[
					{
						required: true,
						message: '请输入联系方式',
					},
				],
				'qq':[
					{
						required: true,
						message: '请输入您的QQ',
					},
				],
			},
		};
	}
	
	componentDidMount()
	{
		let query = getQuery();
		let initData = {
			'attachment':[],
		};
		if(query.orderSn)
			initData['order_sn'] = query.orderSn;
		
		this.mainForm.setFieldsValue(initData);
		this.getSolutionList();
		
		document.title = '申请售后 - ' + CommonValue.get('site_name');
	}
	handleRemoveImage(file)
	{
		return new Promise((resolve,reject)=>{
			confirm('确认要删除该图片吗?')
				.then(()=>{
					let url = pcUrl('user','deleteFile');
					let param = {
						'file':[
							file.thumbUrl,
							file.url,
						].join(','),
					};
					httpPost(url,param)
						.then(()=>{
							resolve();
						});
				})
				.catch(()=>{
					reject();
				});
		});
	}
	handlePreviewImage(file)
	{
		this.setState({
			'preview':{
				'visible':true,
				'src':file.url,
			},
		});
	}
	
	handleUploadChange(data)
	{
		if(data.fileList.length)
		{
			data.fileList.forEach((row,index)=>{
				if(row.response)
				{
					let response = row.response;
					if(response.code != 0)
					{
						message(response.message);
						return;
					}
					
					data.fileList[index] = {
						'uid':index+1,
						'name':'',
						'status':'done',
						'thumbUrl':response.data,
						'url':response.data.replace('thumb.',''),
					};
				}
			});
			data.fileList = data.fileList.filter(row=>{
				if(row.response && row.response.code != 0)
					return false;
				else
					return true;
			});
		}
		this.mainForm.setFieldsValue({
			'attachment':data.fileList,
		});
		/*
		if(data.file)
		{
			//if(data.file.status == 'removed')
			if(1)
			{
			}
		}
		*/
	}
	
	getSolutionList()
	{
		let url = pcUrl('orderService','solutionList');	
		httpPost(url)
			.then(data=>{
				this.setState({
					'reasonList':data['reason_list'],
					'solutionList':data['solution_list'],
				});
			});
	}
	
	reset()
	{
		this.mainForm && this.mainForm.resetFields();
		this.mainForm && this.mainForm.setFieldsValue({
			'attachment':[],
		});
	}
	
	submit(data)
	{
		confirm('您的填写无误并确定要提交吗?')
			.then(()=>{
				let url = pcUrl('orderService','add');
				let param = data;
				param['attachment'] = param['attachment'].map(row=>{
					return row['thumbUrl'];
				}).join(',');
				
				httpPost(url,param)
					.then(()=>{
						//this.reset();
						
						message('您售后反馈已经提交成功，我们会在2个工作日内对您的反馈进行处理，谢谢您对我们的支持','success');
						this.back();
					});
			});
	}
	
	back()
	{
		//window.history.back();
		//window.location.href = ngUrl('user','orderService');
		this.props.history.goBack();
	}
	
	render()
	{
		return (
			<div style={{'padding':'1.5em 1.5em 2em 1.5em'}}>
				<div className="text-right" style={{'margin-bottom':'1.5em'}}>
					<button className="button button-green" style={{'font-size':'12px','border-radius':'5px'}} onClick={()=>this.back()}> &lt;&lt; 返回 </button>
				</div>
				<div style={{'padding':'0 4em'}}>
					<Steps size="small" current={0} status={'progress'}>
						<Steps.Step title="提交申请" />
						<Steps.Step title="客服处理" />
						<Steps.Step title="处理完成" />
					</Steps>
				</div>
				<div className="height-20"></div>
				<div className="notice">
					<span className="fa fa-info-circle"></span>
					&nbsp;
					请填写售后原因及意向解决方案
				</div>
				<div className="height-20"></div>
				<div className="aftersale-left">
					<Form
						ref={e=>this.mainForm = e}
						onFinish={(data)=>this.submit(data)}
						onFinishFailed={data=>this.focusError()}
						labelCol={{ span:5 }}
						wrapperCol={{ span:19 }}>
						<Form.Item name="service_reason" label="售后原因" rules={this.state.rules['service_reason']}>
							<Select placeholder="请选择售后原因">
								{Object.keys(this.state.reasonList).map(key=>(
									<Option value={key}>{this.state.reasonList[key]}</Option>
								))}
							</Select>
						</Form.Item>
						<Form.Item name="order_sn" label="订单号" rules={this.state.rules['order_sn']}>
							<Input />
						</Form.Item>
						
						<Form.Item name="product_name" label="产品名称" rules={this.state.rules['product_name']}>
							<Input />
						</Form.Item>
						
						<Form.Item name="problem_desc" label="问题描述" rules={this.state.rules['problem_desc']}>
							<Input.TextArea rows={5} placeholder="请输入具体问题描述"/>
						</Form.Item>
						
						<Form.Item name="service_solution" label="意向解决方案" rules={this.state.rules['service_solution']}>
							<Select placeholder="请选择意向解决方案">
								{Object.keys(this.state.solutionList).map(key=>(
									<Option value={key}>{this.state.solutionList[key]}</Option>
								))}
							</Select>
						</Form.Item>
						
						<Form.Item name="attachment" rules={this.state.rules['attachment']}  hidden/>
						<Form.Item shouldUpdate label="上传凭证" rules={this.state.rules['attachment']}>
							{()=>(
								<>
									<div style={{'margin':'5px 0 1em 0'}}>
										为了快速为您解决售后问题，
										<span className="text-orange"> 请上传成品出现问题局部照片和问题整体合照 </span>
									</div>
									<Upload
										action={pcUrl('index','upload')}
										showUploadList={true}
										onRemove={file=>this.handleRemoveImage(file)}
										onChange={data=>this.handleUploadChange(data)}
										onPreview={file=>this.handlePreviewImage(file)}
										fileList={this.mainForm && this.mainForm.getFieldValue('attachment')}
										data={{'thumb_size':'500,500'}}
										listType="picture-card">
											{this.mainForm && this.mainForm.getFieldValue('attachment') && this.mainForm.getFieldValue('attachment').length < 5 ?(
											<div>
												{/*
												<Button style={{'width':'8em'}}>
													点击上传
												</Button>
												*/}
												<span style={{fontSize:'20px'}}>+</span>
												<br/>
												上传图片
											</div>
											):''}
									</Upload>
									<p>
										支持选择五个文件，允许的文件类型：jpg，gif，jpeg，且不超过10MB
									</p>
									<Image preview={{...this.state.preview,'onVisibleChange':val=>{let preview = this.state.preview; preview.visible = val; this.setState({'preview':{...preview}});}}} />
									<div style={{'margin':'.5em 0 0 0 ','white-space':'nowrap'}} className="text-orange">
										<span className="fa fa-info-circle"></span>
										温馨提示：
										<br />
										<span>
											请补充支持售后原因的快递面单、发货标签、货物整体、第三方交易相关说明
										</span>
									</div>
								</>
							)}
						</Form.Item>
						
						<Form.Item name="phone" label="联系方式" rules={this.state.rules['phone']}>
							<Input placeholder="请输入您的联系方式" />
						</Form.Item>
						
						<Form.Item name="qq" label="QQ" rules={this.state.rules['qq']}>
							<Input placeholder="请输入您的QQ" />
						</Form.Item>
						
						<Form.Item shouldUpdate wrapperCol={{ offset:5 }}>
							<Button type="primary" htmlType="submit" style={{'width':'8em','height':'36px'}}>立即提交</Button>
							&nbsp;&nbsp;
							&nbsp;&nbsp;
							<Button style={{'width':'6em','height':'36px'}} onClick={()=>this.reset()} >重置</Button>
						</Form.Item>
					</Form>
				</div>
				<div className="aftersale-right">
					<img src={require('@/assets/images/aftersale_notice.jpg')} />
				</div>
				<div className="clear"></div>
			</div>
		);
	}
}

